import { render, staticRenderFns } from "./RequestTable.vue?vue&type=template&id=7a8fd8aa&scoped=true"
import script from "./RequestTable.vue?vue&type=script&lang=js"
export * from "./RequestTable.vue?vue&type=script&lang=js"
import style0 from "./RequestTable.vue?vue&type=style&index=0&id=7a8fd8aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8fd8aa",
  null
  
)

export default component.exports